<script lang="ts">
    import { mdiClipboardText, mdiTag } from "@mdi/js"
    import { tooltip } from "../../../helper"
    import { _ } from "svelte-i18n"
    import Icon from "../Icon.svelte"

    export let operation: Operation
    export let positionNumber: number = null

    $: tooltipData = {
        content:
            (operation.type == 1
                ? $_("components.table.fields.number.offerNumber", {
                      values: {
                          operationNumber: operation.number,
                      },
                  })
                : $_("components.table.fields.number.orderNumber", {
                      values: {
                          operationNumber: operation.number,
                      },
                  })) +
            (positionNumber
                ? $_("components.table.fields.number.positionNumber", {
                      values: {
                          positionNumber: positionNumber,
                      },
                  })
                : ""),
    }
</script>

<span use:tooltip="{tooltipData}">
    <span class="table_icon"><Icon path="{operation.type == 1 ? mdiTag : mdiClipboardText}" /></span>
    {operation.number}
    {#if positionNumber}
        / {$_("general.positionShortName")} {positionNumber}
    {/if}
</span>
